module.exports = __webpack_public_path__ + "img/records-side.99b6a9de.png";